import { render, staticRenderFns } from "./tenantServices.vue?vue&type=template&id=143d3f1f&scoped=true&"
import script from "./tenantServices.vue?vue&type=script&lang=js&"
export * from "./tenantServices.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=143d3f1f&scoped=true&lang=css&"
import style1 from "./tenantServices.vue?vue&type=style&index=1&id=143d3f1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143d3f1f",
  null
  
)

export default component.exports